// extracted by mini-css-extract-plugin
export var container = "slide-show-module--container--N50aR";
export var desktopImage = "slide-show-module--desktopImage--811nD";
export var image = "slide-show-module--image--tQWPX";
export var imageContainer = "slide-show-module--imageContainer--ryWZ5";
export var imageContainerDesktop = "slide-show-module--imageContainerDesktop--gKcTo";
export var iphone = "slide-show-module--iphone--cu92g";
export var iphoneContainer = "slide-show-module--iphoneContainer--pW1YX";
export var slidein = "slide-show-module--slidein--8JR75";
export var slideinMobile = "slide-show-module--slideinMobile--2oup2";